<shrd-uic-search-field
  name="search"
  class="w-100"
  [autofocus]="autofocus"
  [iconSize]="iconSize"
  [isBarcodeScannerEnabled]="isBarcodeScannerEnabled"
  [barcodeScannerIcon]="iconsName.CAMERA"
  (barcodeScannerTriggered)="onBarcodeScan()"
  [placeholder]="'header.search.placeholder' | i18next"
  [barcodeTitle]="'header.search.inputButtons.barcode' | i18next"
  [buttonTitle]="'header.search.inputButtons.search' | i18next"
  [resetTitle]="'header.search.inputButtons.reset' | i18next"
  [value]="searchTerm$ | async"
  [maxlength]="maxLength"
  [restoreInitialStateOnEmptySearch]="true"
  [usePreloader]="usePreloader"
  [loading]="loading"
  (valueChange)="onSearchAction($event)"
  (searchTextChange)="updateSearchTerm($event)"
  (focusChange)="focusChange.emit($event)"
></shrd-uic-search-field>
<ng-container #modal></ng-container>
